<template>
  <div class="flex-col gap-y-lg">
    <CoverageFields module="$_generic_insurance">
    </CoverageFields>
  </div>
</template>

<script>
import CoverageFields from './CoverageFields.vue';
export default {
  name: "Coverages",
  components: {
    CoverageFields,
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
